module.exports = __webpack_public_path__ + "static/logo-c76eb0949197917934c6d930a447f23c.png";